
let bodynext = document.querySelector("body").getAttribute("date-next")
const endDate = new Date(bodynext).getTime();

//Timer code :
const seconds = 1000;
const minutes = seconds * 60;
const hours = minutes * 60;
const days = hours * 24;
const timerHours = document.getElementsByClassName("block_timer-hours");
const timerMinutes = document.getElementsByClassName("block_timer-minutes");
const timerSeconds = document.getElementsByClassName("block_timer-seconds");

const x = setInterval(function () {
  let nowDate = new Date();
  let mainDate =  nowDate.toLocaleString('en-US', { timeZone: 'America/New_York' })  
  let bodyText = new Date(mainDate).getTime();
  const difference = endDate - bodyText;  

  Array.from(timerHours).forEach(
    (hoursEl) => (hoursEl.innerText = Math.floor((difference % days) / hours))
  );
  Array.from(timerMinutes).forEach(
    (minutesEl) =>
      (minutesEl.innerText = Math.floor((difference % hours) / minutes))
  );
  Array.from(timerSeconds).forEach(
    (secondsEl) =>
      (secondsEl.innerText = Math.floor((difference % minutes) / seconds) )
  );  
}, seconds);




if(document.querySelectorAll('.block_instock-message').length > 0){
let inStock = document.querySelector(".block_instock-message .block_product-text-with-icon-text b");
let textBefor = document.querySelector('.block_instock-message').getAttribute("data-before")
let textAfter = document.querySelector('.block_instock-message').getAttribute("data-after")
let textNext = document.querySelector('.block_instock-message').getAttribute("data-next")


setInterval(function() {
	let date = new Date();
	const easternTime = date.toLocaleString("en-US", {timeZone: "America/New_York"});
	let bodyText = new Date(easternTime);
	let days = bodyText.getDay();
	let h = bodyText.getHours(),
		m = bodyText.getMinutes();

	if (bodyText.getDay() === 0 || bodyText.getDay() === 6 || bodyText.getDay() === 5 ) {
      if (bodyText.getDay() === 5) {
			if (h < 14 && m > 0) {
				inStock.innerHTML = textBefor;
			} else {
				inStock.innerHTML = textNext;
			}
		} else {
			inStock.innerHTML = textNext;
		}
        
	} else {
		if (h >= 14 && m > 0) {
			inStock.innerHTML = textAfter;  
		} else {             
			inStock.innerHTML = textBefor;
		}
	}
}, 1000);
}




function reloadAtMidnight() {
  let date = new Date();
  let easternTimeRefresh = date.toLocaleString("en-US", {timeZone: "America/New_York"});
    const now = new Date(easternTimeRefresh);
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentSecond = now.getSeconds();

    const timeUntilMidnight = (
        (24 - currentHour) * 60 * 60 * 1000 - 
        currentMinute * 60 * 1000 - 
        currentSecond * 1000
    );
    setTimeout(function() {
        location.reload();
    }, timeUntilMidnight);
}

reloadAtMidnight();

document.addEventListener("DOMContentLoaded", function(event) {
  if (window.location.href.indexOf("?cart") > -1) {
      document.querySelector("#cart-icon-bubble").click();
  }
  setTimeout(() =>{
    if (window.location.href.indexOf("?cart") > -1) {
        window.history.pushState({}, document.title, `${document.querySelector("body").getAttribute("data-shop")}`);
    }
  } , 1000)
})
